import { Component, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { IMetaData, INumberMetaDataSettings } from "src/app/interfaces";

@Component({
    selector: "circ-metadata-number",
    templateUrl: "./number.component.html",
    styleUrls: ["./number.component.scss"],
    standalone: false
})
export class NumberComponent implements OnInit {
  @Input()
  @Output()
  public data: IMetaData;

  @Input()
  public formGroup: FormGroup;

  public settings: INumberMetaDataSettings;
  public placeholder: string;

  ngOnInit(): void {
    this.settings = {
      ...this.data.settings
    } as INumberMetaDataSettings;

    if (
      typeof this.settings.min === "number" &&
      typeof this.settings.max === "number"
    ) {
      this.placeholder = this.settings.min + " - " + this.settings.max;
    } else if (typeof this.settings.min === "number") {
      this.placeholder = "< " + this.settings.min;
    } else if (typeof this.settings.max === "number") {
      this.placeholder = "> " + this.settings.max;
    }
  }
}
